(function () {
  var searchInput = document.getElementById('koi-encyclopedia-search');
  var categorySelect = document.getElementById('koi-encyclopedia-category');
  var sortSelect = document.getElementById('koi-encyclopedia-sort');
  var grid = document.getElementById('koi-encyclopedia-grid');
  var countEl = document.getElementById('koi-encyclopedia-count');
  var clearBtn = document.getElementById('koi-encyclopedia-clear');
  var noResults = document.getElementById('koi-encyclopedia-no-results');
  var description = document.getElementById('koi-encyclopedia-description');

  if (!grid) return;

  var cards = Array.from(grid.querySelectorAll('[data-koi-variety-card]'));

  function filterAndSort() {
    var query = searchInput.value.toLowerCase().trim();
    var category = categorySelect.value;
    var sort = sortSelect.value;

    var visible = [];
    var hidden = [];

    cards.forEach(function (card) {
      var name = card.dataset.name.toLowerCase();
      var jpName = (card.dataset.japaneseName || '').toLowerCase();
      var pronunciation = (card.dataset.pronunciation || '').toLowerCase();
      // colors, scale type, metallic/ginrin, and the name's English meaning,
      // so beginners can search the way they think ("orange", "doitsu")
      var extraSearch = (card.dataset.search || '').toLowerCase();
      var cardCategory = card.dataset.category;
      // pattern family too, so "gosanke" or "hikari" finds the group
      var categoryText = (cardCategory || '').toLowerCase();

      var show = true;
      if (
        query &&
        name.indexOf(query) === -1 &&
        jpName.indexOf(query) === -1 &&
        pronunciation.indexOf(query) === -1 &&
        extraSearch.indexOf(query) === -1 &&
        categoryText.indexOf(query) === -1
      ) {
        show = false;
      }
      if (category && cardCategory !== category) show = false;

      if (show) {
        visible.push(card);
      } else {
        hidden.push(card);
      }
    });

    visible.sort(function (a, b) {
      switch (sort) {
        case 'name-desc':
          return b.dataset.name.localeCompare(a.dataset.name);
        default:
          return a.dataset.name.localeCompare(b.dataset.name);
      }
    });

    var frag = document.createDocumentFragment();
    hidden.forEach(function (c) { c.style.display = 'none'; });
    visible.forEach(function (c) { c.style.display = ''; frag.appendChild(c); });
    grid.appendChild(frag);

    countEl.textContent = visible.length + ' variet' + (visible.length === 1 ? 'y' : 'ies');
    noResults.hidden = visible.length !== 0;
    if (visible.length === 0) {
      var queryEl = noResults.querySelector('[data-no-results-query]');
      if (queryEl) queryEl.textContent = searchInput.value.trim() ? '\u201c' + searchInput.value.trim() + '\u201d' : 'these filters';
    }
    clearBtn.hidden = !(query || category || sort !== 'name-asc');

    // Update URL params without reload
    var url = new URL(window.location);
    if (query) url.searchParams.set('q', query); else url.searchParams.delete('q');
    if (category) url.searchParams.set('category', category); else url.searchParams.delete('category');
    if (sort && sort !== 'name-asc') url.searchParams.set('sort', sort); else url.searchParams.delete('sort');
    history.replaceState(null, '', url);
  }

  // Debounced search
  var timer;
  searchInput.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(filterAndSort, 200);
  });
  categorySelect.addEventListener('change', filterAndSort);
  sortSelect.addEventListener('change', filterAndSort);
  function resetFilters() {
    searchInput.value = '';
    categorySelect.value = '';
    sortSelect.value = 'name-asc';
    filterAndSort();
  }
  clearBtn.addEventListener('click', resetFilters);

  // No-match state: suggestion chips run a search that is known to match,
  // with the category cleared so the chip can't be filtered back to zero
  noResults.addEventListener('click', function (e) {
    var suggestion = e.target.closest('[data-suggest]');
    if (suggestion) {
      searchInput.value = suggestion.dataset.suggest;
      categorySelect.value = '';
      filterAndSort();
      searchInput.focus();
      return;
    }
    if (e.target.closest('[data-encyclopedia-reset]')) {
      resetFilters();
      searchInput.focus();
    }
  });

  // Phones: the intro's middle paragraphs (how to use the page) fold behind
  // "Read more" so the search and the first varieties reach the first screen.
  // The first paragraph and the closing shop link always stay visible.
  if (description) {
    var paragraphs = Array.from(description.children).filter(function (el) { return el.tagName === 'P'; });
    if (paragraphs.length >= 3) {
      description.setAttribute('data-collapsed', '');
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'koi-encyclopedia__more';
      more.textContent = 'Read more';
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function () {
        description.removeAttribute('data-collapsed');
        more.remove();
        paragraphs[1].setAttribute('tabindex', '-1');
        paragraphs[1].focus({ preventScroll: true });
      });
      paragraphs[0].after(more);
    }
  }

  // Initialize from URL params
  var params = new URLSearchParams(window.location.search);
  if (params.get('q')) searchInput.value = params.get('q');
  if (params.get('category')) categorySelect.value = params.get('category');
  if (params.get('sort')) sortSelect.value = params.get('sort');

  filterAndSort();

  // ---- Live availability badges ----
  // The variety facet counts come from the koi collection's rendered filters
  // (same section-render trick the variety detail pages use). Cards are keyed
  // by metaobject handle (last segment of the card href); chip labels reduce
  // to the same handle via the theme's label-handleize convention.
  function handleize(str) {
    return String(str)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function addAvailabilityBadges() {
    var collection = grid.dataset.listingsCollection;
    if (!collection) return;

    fetch('/collections/' + encodeURIComponent(collection) + '?section_id=main-collection-product-grid')
      .then(function (response) {
        if (!response.ok) throw new Error('facet fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var counts = {};
        var group = doc.querySelector('.koi-quick-filters__group[data-facet="Variety"]');
        if (!group) return;
        group.querySelectorAll('.koi-chip').forEach(function (chip) {
          var label = chip.querySelector('.koi-chip__label');
          var count = chip.querySelector('.koi-chip__count');
          if (!label || !count) return;
          var value = parseInt(count.textContent, 10);
          if (value > 0) counts[handleize(label.textContent)] = value;
        });

        cards.forEach(function (card) {
          var handle = (card.getAttribute('href') || '').split('?')[0].split('/').filter(Boolean).pop();
          var available = counts[handle];
          if (!available) return;
          var meta = card.querySelector('.koi-variety-card__meta');
          if (!meta || meta.querySelector('.koi-variety-card__badge--stock')) return;
          var badge = document.createElement('span');
          badge.className = 'koi-variety-card__badge koi-variety-card__badge--stock';
          badge.textContent = available + ' for sale';
          meta.insertBefore(badge, meta.firstChild);
        });
      })
      .catch(function () {
        /* badges are progressive enhancement; the page works without them */
      });
  }

  addAvailabilityBadges();
})();
